export class RegisterPushIdRequest {
  public uuid: string;
  public platform: number;
  public pushId: string;

  constructor() {
    this.uuid = '';
    this.platform = 0;
    this.pushId = '';
  }
}
